var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8297 18.9307C5.45342 17.4612 6.90968 16.4305 8.60666 16.4305H14.7586C16.4555 16.4305 17.9118 17.4612 18.5355 18.9307M15.7839 8.74065C15.7839 11.0057 13.9477 12.8419 11.6826 12.8419C9.41754 12.8419 7.58134 11.0057 7.58134 8.74065C7.58134 6.47559 9.41754 4.63939 11.6826 4.63939C13.9477 4.63939 15.7839 6.47559 15.7839 8.74065ZM21.9358 11.3039C21.9358 16.9666 17.3453 21.5571 11.6826 21.5571C6.01994 21.5571 1.42944 16.9666 1.42944 11.3039C1.42944 5.64128 6.01994 1.05078 11.6826 1.05078C17.3453 1.05078 21.9358 5.64128 21.9358 11.3039Z",
    stroke: "#38CB89",
    strokeWidth: 2.05063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCircleGreen);
export default __webpack_public_path__ + "static/media/users-circle-green.ac3e1e42e9e00413b99bb88bf7f2bf93.svg";
export { ForwardRef as ReactComponent };